import type {
  ReactElement,
} from 'react';

import { components } from 'react-select';
import type { InputProps } from 'react-select';

export function Input(props: InputProps): ReactElement {
  return (
    <components.Input
      {...props}
      data-n3__select-input=""
    />
  );
}
